import Rails from '@rails/ujs';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.WarrantyShipping.init());

Sq.Shop.WarrantyShipping = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#warranty-shipping-page').length === 0) {
      return;
    }

    this.getHtml();
    this.setDefaultData();
    this.bindEvents();
  },

  getHtml() {
    this.$form = $('#warranty-shipping-form');
    this.$continueBtn = $('#continue-with-po-box-button');
    this.$editBtn = $('#edit-po-box-button');
  },

  setDefaultData() {
    this.submitWithPOBox = false;
  },

  bindEvents() {
    this.$form.on('ajax:beforeSend', () => {
      return this.$form.data('sq.form').validate();
    });

    this.$form.on('submit', (e) => {
      const address_line_1 = $('#address_address_line_1').val();
      const address_line_2 = $('#address_address_line_2').val();

      const pobox_address_regex = /(((p[\s.]?[\so]\.?)\s?)|(post\s?office\s?))((box|bin|b\.?)?\s?(num|number|#)?\s?\d+)/gim;
      if (
        pobox_address_regex.test(address_line_1) ||
        pobox_address_regex.test(address_line_2)
      ) {
        if (!this.submitWithPOBox) {
          e.preventDefault();
          Sq.Modals.get('pobox-confirmation').activate();
          return false;
        }
      }
    });

    this.$continueBtn.on('click', () => {
      Sq.Modals.get('pobox-confirmation').deactivate();
      this.submitWithPOBox = true;
      Rails.fire(this.$form[0], 'submit');
    });

    this.$editBtn.on('click', () => {
      Sq.Modals.get('pobox-confirmation').deactivate();
      this.$form.attr('data-loading', false);
    });
  },
};
